import {
  Component,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { environment } from 'src/environments/environment';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';
import { ANNOUNCED_CONTRACTED } from 'src/app/onelog/common/config/url';
import { DateSelectComponent } from 'src/app/onelog/common/fields/date-select/date-select.component';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CustomEvents} from 'src/app/onelog/classes/CustomEvent'
import { FilterData, ResponsePaginated} from 'src/app/onelog/interface/CustomTypes';

@Component({
  selector: 'app-announced-contracted',
  templateUrl: './announced-contracted.component.html',
  styleUrls: ['./announced-contracted.component.css']
})
export class AnnouncedContractedComponent {

  @ViewChildren(DateSelectComponent) NgbDate: QueryList<DateSelectComponent>;

  constructor(
    private requestService: RequestService,
  ) {}

  apiURL = environment.sachWebURL;
  selectedproductId: string = '';
  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];
  selectStarFilterDate: any = [];
  filterData : Partial<FilterData> = {
    announced : {},
    contracted : {}
  };
  selectEndFilterDate: any = [];
  successToastShow: boolean = false;

  ngOnInit(): void {
    this.filterData['announced'] = {};
    this.filterData['contracted'] = {};
    this.loadProducts(this.createPostData());
  }

  loadProducts(postData: any = [], url: string = ANNOUNCED_CONTRACTED) {
    return this.requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        let responseData : ResponsePaginated = data
        this.products = responseData.data;
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
        this.setPaginationData(responseData);
      });
  }

  setPaginationData(responseData : any){
    this.totalProducts = responseData.total;
    this.perPage = responseData.per_page;
    this.lastPage = Math.floor(this.totalProducts / this.perPage) + 1;
    this.currentPage = responseData.current_page;
  }

  createPostData() {
    return {
      selectedDate: Object.assign({}, this.filterData),
      page: this.currentPage,
    };
  }

  downloadReport() {
      this.requestService.download(
        ANNOUNCED_CONTRACTED,
        {
          is_download: 1,
          selectedDate: Object.assign({}, this.filterData),
          page: this.currentPage,
        },
        '',
        'announced_contracted_report'
      );
  
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.loadProducts(this.createPostData());
  }

  updateSelectedDate(event: CustomEvents) {
    
    if (event.type == 'announcedStartDate') {
      this.filterData['announced'] = this.filterData['announced'] || {};
      this.filterData['announced']['startDate'] =  event.dateString;
    }

    if (event.type == 'announcedEndDate') {
      this.filterData['announced'] = this.filterData['announced'] || {};
      this.filterData['announced']['endDate'] =  event.dateString;
    }

    if (event.type == 'contractedStartDate') {
      this.filterData['contracted'] = this.filterData['contracted'] || {};
      this.filterData['contracted']['startDate'] = event.dateString;
      
    }

    if (event.type == 'contractedEndDate') {
      this.filterData['contracted'] = this.filterData['contracted'] || {};
      this.filterData['contracted']['endDate'] = event.dateString;
      
    }

  }

  updatePageData(event: CustomEvents) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    console.log(eventData, urlParams);
    this.loadProducts(this.createPostData());
  }

  clearFilters() {
    this.clearAllDates();
  }

  clearAllDates(): void {
    this.NgbDate.forEach((datePickerComp) => {
      datePickerComp.clearDate();
    });

    this.filterData['announced'] = {};
    this.filterData['contracted'] = {};
  }


}
